<template>
  <div class="flex flex-1 gap-4">
    <SvPicker v-model:rgb="rgb" @change="changeColor" />
    <div class="flex-1 flex flex-col justify-end">
      <HuePicker v-model:rgb="rgb" @change="changeColor" />
      <RgbInput v-model="rgb" @change="changeColor" />
      <CurrentInput
        v-model="rgb"
        :rgb-group="rgbGroup"
        :has-liner-gradient="false"
        :gradient-direction="gradientDirection"
        :is-colorful="isColorful"
        @change="changeColor"
      />
      <PreColorRadio
        v-model="rgb"
        :has-colorful="false"
        :is-colorful="false"
        @change="changeColor"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  import type { lightingColor, RGB, RGBGroup } from '@rapoo/device-sdk'

  import SvPicker from '@/components/colorPicker/svPicker.vue'
  import HuePicker from '@/components/colorPicker/huePicker.vue'
  import RgbInput from '@/components/colorPicker/rgbInput.vue'
  import CurrentInput from '@/components/colorPicker/currentInput.vue'
  import PreColorRadio from '@/components/colorPicker/preColorRadio.vue'

  const props = withDefaults(
    defineProps<{
      modelValue?: RGB
      rgbGroup?: RGBGroup
      isColorful?: boolean
      gradientDirection?: number
    }>(),
    {
      modelValue: () => ({ r: 0, g: 0, b: 0 }),
    },
  )
  const emit = defineEmits(['update:modelValue', 'change', 'update:rgbGroup'])

  const rgb = computed({
    get() {
      return props.modelValue
    },
    set(val) {
      emit('update:modelValue', val)
    },
  })

  const changeColor = (val: lightingColor) => {
    emit('change', val)
  }
</script>
